import { useContext, useEffect } from 'react';
import SubscriptionContext from 'src/context/subscription';
import AccountsService from 'src/services/AccountsService';
import { useQuery } from 'react-query';
import { storeSubscription } from 'src/storage/subscription';

const FlipperCheck = (subId) => {
  const { subscriptionContext, setSubscriptionContext } =
    useContext(SubscriptionContext);

  if (subscriptionContext.subId) {
    const flipperCheck = useQuery('flipper', async () => {
      const data = await AccountsService.checkFlipper(
        subId || subscriptionContext.subId
      );
      return data;
    });

    useEffect(() => {
      if (flipperCheck.data) {
        const newContext = {
          ...subscriptionContext,
          flipperContext: {
            flipper: flipperCheck.data?.data?.flipper ?? false,
            subscription_id: flipperCheck.data?.data?.subscription_id ?? '',
            org_id: flipperCheck.data?.data?.org_id ?? '',
            site_id: flipperCheck.data?.data?.site_id ?? '',
            job_cost_v4: flipperCheck.data?.data?.job_cost_v4 ?? false,
          },
        };
        setSubscriptionContext(newContext);
        storeSubscription({
          subId: subscriptionContext.subId,
          token: subscriptionContext.token,
        });
      }
    }, [flipperCheck.data]);
  }
};

export default FlipperCheck;
